<template>
  <BasePullRefresh
    v-model="refreshLoading"
    :pulling-text="$t('notifications.system.pulling')"
    :loosing-text="$t('notifications.system.loosing')"
    @refresh="onRefresh"
  >
    <div class="flex flex-col gap-4">
      <!-- <CategoriesHead
        v-if="category && categorySorts"
        :category="category"
        :sorts="categorySorts"
      /> -->
      <CategoriesHead v-if="category && categorySorts" :category="category" />
      <NewsList :list="newsStore.list.hits" :loaded="newsStore.list.loaded" />
      <BaseObserve
        v-if="newsStore.list.loaded && !newsStore.allRecordsLoaded"
        @change="nextPage"
      />
    </div>
  </BasePullRefresh>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { MenuItem } from '~/models/menu'
import { useNews } from '~/stores/news'
import { useAuth } from '~/stores/auth'
import { NewsEndpointMap } from '~/models/news'
import { NavigationSortType } from '~/models/navigation'
import type { Category } from '~/models/navigation'
interface PropsInterface {
  sortType: NavigationSortType
  category?: Category
  categorySorts?: MenuItem[]
}

const props = defineProps<PropsInterface>()

const newsStore = useNews()
const authStore = useAuth()
const i18n = useI18n()

const refreshLoading = ref(false)

const newsEndpoint = computed(() =>
  authStore.auth ? NewsEndpointMap.Auth : NewsEndpointMap.Base
)

async function getNewsList(): Promise<void> {
  newsStore.resetNewsListWithSorting(
    newsEndpoint.value,
    props.sortType,
    props.category?.id
  )
  await newsStore.getNews()
}

async function nextPage(visible: boolean): Promise<void> {
  if (visible) {
    await newsStore.nextPage()
  }
}

function onRefresh() {
  newsStore.reload()
  refreshLoading.value = false
}

onServerPrefetch(async () => {
  await getNewsList()
})

onBeforeMount(async () => {
  await getNewsList()
})

watch(
  () => !!authStore.auth,
  () => {
    getNewsList()
  }
)

watch(i18n.locale, () => {
  getNewsList()
})
</script>
